import Component from '../../../shared/component';

// Constants
const FACE_COLOR_SYNCHRONIZED_CATEGORIES = ['accessory_hand'];

export default class AvatarBuilderPreview extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
  }

  setOptionsConfig(optionsConfig) {
    this.optionsConfig = optionsConfig;
  }

  updatePreview(avatarConfiguration) {
    Object.keys(avatarConfiguration).forEach((categoryName) => {
      const $categoryLayer = this.$element.find(
        `.menteeAvatarBuilderModal-header-avatar-categoryLayer[data-category=${categoryName}]`
      );
      const requiredCategory = $categoryLayer.data('required');

      if (
        !this.shouldUpdateCategoryPreview(
          avatarConfiguration,
          requiredCategory,
          categoryName
        )
      ) {
        if (!requiredCategory) $categoryLayer.hide();
        return;
      }

      this.updateCategoryLayerImageUrl(
        $categoryLayer,
        categoryName,
        avatarConfiguration
      );
    });
  }

  shouldUpdateCategoryPreview(
    avatarConfiguration,
    requiredCategory,
    categoryName
  ) {
    if (requiredCategory)
      return this.isRequiredCategoryConfigurationComplete(
        avatarConfiguration,
        categoryName
      );

    const avatarCategoryConfiguration = avatarConfiguration[categoryName];
    return avatarConfiguration && avatarCategoryConfiguration.option !== null;
  }

  updateCategoryLayerImageUrl(
    $categoryLayer,
    categoryName,
    avatarConfiguration
  ) {
    const assetImageUrl = this.lookupAssetImageUrl(
      categoryName,
      avatarConfiguration
    );

    $categoryLayer.css('background-image', `url(${assetImageUrl})`);
    $categoryLayer.show();
  }

  lookupAssetImageUrl(categoryName, avatarConfiguration) {
    const avatarCategoryConfiguration = avatarConfiguration[categoryName];
    const categoryOption = this.getCategoryOption(
      categoryName,
      avatarCategoryConfiguration
    );

    if (this.isClippedAssetRequired(categoryName, avatarConfiguration))
      return categoryOption.assets[avatarCategoryConfiguration.color].altImages
        .clipped;
    if (this.isFaceColorSynchronizedCategory(categoryName))
      return categoryOption.assets[avatarConfiguration.face.color].image;
    if (avatarCategoryConfiguration.color)
      return categoryOption.assets[avatarCategoryConfiguration.color].image;

    return categoryOption.asset.image;
  }

  getCategoryOption(categoryName, avatarCategoryConfiguration) {
    const categoryConfigurations = this.optionsConfig[categoryName];
    return categoryConfigurations.find(
      (categoryConfiguration) =>
        categoryConfiguration.id === avatarCategoryConfiguration.option
    );
  }

  isRequiredCategoryConfigurationComplete(avatarConfiguration, category) {
    const values = Object.values(avatarConfiguration[category]);

    return !values.includes(null);
  }

  isClippedAssetRequired(categoryName, avatarConfiguration) {
    return (
      categoryName === 'hair' &&
      this.avatarConfigurationContainsHairClippingAccessory(avatarConfiguration)
    );
  }

  isFaceColorSynchronizedCategory(categoryName) {
    return FACE_COLOR_SYNCHRONIZED_CATEGORIES.includes(categoryName);
  }

  avatarConfigurationContainsHairClippingAccessory(avatarConfiguration) {
    if (avatarConfiguration.accessory_head.option === null) return false;

    const avatarCategoryConfiguration = avatarConfiguration.accessory_head;
    const categoryOption = this.getCategoryOption(
      'accessory_head',
      avatarCategoryConfiguration
    );

    return categoryOption.clipsHair;
  }
}
